import type { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';
import type { OnChangeFn } from '@tanstack/react-table';
import { createColumnHelper } from '@tanstack/react-table';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import type { SaltMinionListItem } from '../hooks/SaltMinion';
import BaseHtmlTable from '../table/BaseHtmlTable';

const columnHelper = createColumnHelper<SaltMinionListItem>();

type TableProps = {
  rows?: SaltMinionListItem[];
  loading?: boolean;
  page?: number;
  totalPages?: number;
  total?: number;
  perPage?: number;
  serverPagination?: PaginationState;
  onServerPaginationChange?: OnChangeFn<PaginationState>;
  serverSorting?: SortingState;
  onServerSortingChange?: OnChangeFn<SortingState>;
  serverColumnFilters?: ColumnFiltersState;
  onServerColumnFiltersChange?: OnChangeFn<ColumnFiltersState>;
};

const Table: React.FC<TableProps> = (props) => {
  const {
    rows,
    loading,
    page,
    totalPages,
    total,
    perPage,
    serverPagination,
    onServerPaginationChange,
    serverSorting,
    onServerSortingChange,
    serverColumnFilters,
    onServerColumnFiltersChange,
  } = props;
  const resolvedRows = rows ?? [];
  const resolvedLoading = loading ?? false;
  const serverControlled =
    serverPagination != null &&
    onServerPaginationChange != null &&
    serverSorting != null &&
    onServerSortingChange != null &&
    serverColumnFilters != null &&
    onServerColumnFiltersChange != null;

  const columnDefs = useMemo(
    () => [
      columnHelper.accessor('id', {
        id: 'id',
        header: 'ID',
      }),
      columnHelper.display({
        id: 'actions',
        header: '',
        cell: (ctx) =>
          <Link
            className="btn btn-secondary btn-sm text-decoration-none"
            to={`/salt-minions/view/${ctx.row.original.id}`}>
            View
          </Link>
      }),
    ],
    []
  );

  return (
    <BaseHtmlTable
      rows={resolvedRows}
      columnDefs={columnDefs}
      loading={resolvedLoading}
      page={page ?? 1}
      totalPages={totalPages ?? 1}
      total={total ?? resolvedRows.length}
      perPage={perPage ?? 100}
      paginationMode={serverControlled ? 'server' : 'client'}
      {...(serverControlled
        ? {
            serverPagination,
            onServerPaginationChange,
            serverSorting,
            onServerSortingChange,
            serverColumnFilters,
            onServerColumnFiltersChange,
          }
        : {})}
    />
  );
};

export default Table;
